import { render, staticRenderFns } from "./cameraEdit.vue?vue&type=template&id=12fe3a19&scoped=true"
import script from "./cameraEdit.vue?vue&type=script&lang=js"
export * from "./cameraEdit.vue?vue&type=script&lang=js"
import style0 from "./cameraEdit.vue?vue&type=style&index=0&id=12fe3a19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fe3a19",
  null
  
)

export default component.exports